export default __webpack_public_path__ + "static/default-share-image-4090241ba658e870429715964e94f411.jpg";